import { render, staticRenderFns } from "./ProofArchivePage.vue?vue&type=template&id=0fd8c362&scoped=true&"
import script from "./ProofArchivePage.vue?vue&type=script&lang=js&"
export * from "./ProofArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./ProofArchivePage.vue?vue&type=style&index=0&id=0fd8c362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8c362",
  null
  
)

export default component.exports